<template>
  <div class="li" @mouseup="$router.push(path)">
    <span>{{$t(text)}}</span>
    <i class="fhr fhr-chevron-right"></i>
  </div>
</template>

<script>
export default {
  props: ["path", "text"]
}
</script>